// extracted by mini-css-extract-plugin
export default {"header":"CollapsibleList-module__header__+RMRi","collapseButton":"CollapsibleList-module__collapseButton__55UZQ"};